import type { ChangeEventHandler } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { AutosizeInput } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { TITLE_MAX_LENGTH } from "app/pages/keyword-analysis/KeywordGroupEditorHelpers";

import { Left, Right } from "./components/Subtitle";
import { useKeywordGroupNameContext } from "./KeywordGroupNameContext";
import { useKeywordListComposerContext } from "./KeywordListComposerContext";

const ErrorMessage = styled(Text)`
    color: ${colorsPalettes.red["400_P"]};
`;

const Input = styled(AutosizeInput)`
    input {
        padding-left: 0;
    }
`;

export const KeywordListComposerCreatorHeader = () => {
    const t = useTranslation();
    const { keywords } = useKeywordListComposerContext();
    const { keywordGroupName, keywordGroupNameValidationStatus, changeKeywordGroupName } = useKeywordGroupNameContext();
    const { isValid, errorMessage } = keywordGroupNameValidationStatus;

    const onNameChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        changeKeywordGroupName(e.currentTarget.value);
    };

    return (
        <Flex
            flexDirection="column"
            padding="0 0 12px"
        >
            <Box position="relative">
                <Input
                    error={!isValid}
                    placeholder={t("keyword_list_composer.name.placeholder")}
                    onChange={onNameChange}
                    value={keywordGroupName}
                    maxLength={TITLE_MAX_LENGTH}
                />
                {!isValid ? (
                    <Box
                        position="absolute"
                        bottom="-6px"
                    >
                        <ErrorMessage fontVariant="caption">{errorMessage}</ErrorMessage>
                    </Box>
                ) : null}
            </Box>
            <Flex justifyContent="space-between">
                {keywords.length > 0 ? (
                    <Left
                        keywords={keywords}
                        subtitle={t("auto.keyword.list.generator.header.subtitle.amout", { count: keywords.length })}
                    />
                ) : (
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon["500"]}
                    >
                        {t("keyword_list_composer.header.empty_list_title")}
                    </Text>
                )}
                <Right />
            </Flex>
        </Flex>
    );
};
